var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompressorC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF8"
    },
    d: "M273.655,123.586c0-20.946,10.498-39.458,26.483-50.639v-2.326l-114.759,35.31v79.448h114.759 v-11.154C284.152,163.044,273.655,144.532,273.655,123.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C84146"
    },
    d: "M159.233,115.828c-3.887,0-7.457-2.595-8.518-6.535c-1.267-4.707,1.526-9.551,6.232-10.819 l160.733-43.233c4.681-1.267,9.551,1.526,10.819,6.232c1.268,4.706-1.526,9.551-6.232,10.819l-160.733,43.233 C160.767,115.733,159.991,115.828,159.233,115.828z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5050"
    },
    d: "M335.448,194.207c-38.94,0-70.621-31.681-70.621-70.621s31.681-70.621,70.621-70.621 s70.621,31.681,70.621,70.621S374.388,194.207,335.448,194.207z M335.448,70.621c-29.207,0-52.966,23.758-52.966,52.966 s23.758,52.966,52.966,52.966s52.966-23.758,52.966-52.966S364.654,70.621,335.448,70.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5050"
    },
    d: "M493.896,209.974c-4.369-9.543-13.762-15.768-24.258-15.768H42.361 c-10.496,0-19.89,6.225-24.258,15.768C6.795,234.674,0,265.983,0,300.138s6.795,65.464,18.103,90.163 c4.37,9.544,13.762,15.768,24.259,15.768h427.276c10.496,0,19.89-6.225,24.258-15.768c11.307-24.7,18.103-56.008,18.103-90.163 S505.204,234.674,493.896,209.974z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91282D"
    },
    d: "M158.897,229.517c-4.879,0-8.828-3.948-8.828-8.828v-17.655c0-4.879,3.948-8.828,8.828-8.828 c4.879,0,8.828,3.948,8.828,8.828v17.655C167.724,225.569,163.776,229.517,158.897,229.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91282D"
    },
    d: "M353.103,229.517c-4.879,0-8.828-3.948-8.828-8.828v-17.655c0-4.879,3.948-8.828,8.828-8.828 c4.879,0,8.828,3.948,8.828,8.828v17.655C361.931,225.569,357.983,229.517,353.103,229.517z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C84146"
    },
    d: "M379.586,211.862H132.414c-4.875,0-8.828-3.953-8.828-8.828v-17.655c0-4.875,3.953-8.828,8.828-8.828 h247.172c4.875,0,8.828,3.953,8.828,8.828v17.655C388.413,207.91,384.461,211.862,379.586,211.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5050"
    },
    d: "M167.724,185.379c-24.337,0-44.138-19.801-44.138-44.138s19.801-44.138,44.138-44.138 s44.138,19.801,44.138,44.138S192.061,185.379,167.724,185.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB9D2"
    },
    d: "M353.103,105.931h-35.31c-4.875,0-8.828,3.953-8.828,8.828v61.793h52.966v-61.793 C361.931,109.884,357.978,105.931,353.103,105.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C84146"
    },
    d: "M450.207,194.207v167.724c0,4.875-3.953,8.828-8.828,8.828H79.448 c-9.751,0-17.655-7.904-17.655-17.655V194.207H42.361c-10.496,0-19.889,6.225-24.258,15.767C6.795,234.673,0,265.982,0,300.138 c0,34.155,6.795,65.464,18.103,90.164c4.37,9.543,13.763,15.767,24.259,15.767h425.5V194.207H450.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5050"
    },
    d: "M124.758,388.414h-11.17c-4.393,0-8.118,3.23-8.739,7.58l-7.745,54.214h44.138l-7.745-54.214 C132.875,391.644,129.151,388.414,124.758,388.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707487"
    },
    d: "M141.241,459.034H97.103c-4.879,0-8.828-3.948-8.828-8.828c0-4.879,3.948-8.828,8.828-8.828h44.138 c4.879,0,8.828,3.948,8.828,8.828C150.069,455.085,146.121,459.034,141.241,459.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5050"
    },
    d: "M398.412,388.414h-11.17c-4.393,0-8.118,3.23-8.739,7.58l-7.744,54.214h44.138l-7.745-54.214 C406.53,391.644,402.805,388.414,398.412,388.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707487"
    },
    d: "M414.897,459.034h-44.138c-4.879,0-8.828-3.948-8.828-8.828c0-4.879,3.948-8.828,8.828-8.828h44.138 c4.879,0,8.828,3.948,8.828,8.828C423.724,455.085,419.775,459.034,414.897,459.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#959CB5"
    },
    d: "M335.448,105.931h-17.655c-4.875,0-8.828,3.953-8.828,8.828v61.793h17.655v-61.793 C326.621,109.882,330.572,105.931,335.448,105.931z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.966,
    y: 132.414,
    style: {
      fill: "#7F8499"
    },
    width: 52.966,
    height: 17.655
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91282D"
    },
    d: "M167.724,114.759c-14.603,0-26.483,11.88-26.483,26.483s11.88,26.483,26.483,26.483 s26.483-11.88,26.483-26.483S182.327,114.759,167.724,114.759z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompressorC);
export default __webpack_public_path__ + "static/media/compressor_c.bbedbdd7eb17fd75c93e253ad686e007.svg";
export { ForwardRef as ReactComponent };